import React from "react";

const MissionAndVision = ({ valeurClick }) => {
  return (
    <>
      <section className="financier-section financier-section1 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="financier-content">
                <h1>
                  Mission <br />
                  <span> &amp; Vision</span>
                </h1>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="financier-content">
                <p>Déterminés à révolutionner le monde de l’investissement immobilier grâce à l’application de l’expertise actuarielle et des concepts d’ingénierie financière avancée, notre <span> Mission </span> vise à décupler les performances du portefeuille immobilier de nos clients à travers le <span>conseil </span> et l’<span>accompagnement</span> dans toutes les facettes de leurs opérations. </p>
                <p>Faire prospérer et grandir, multiplier et faire fructifier, bâtir et protéger.</p>
                <p>Nous <span>rêvons</span> à un monde où l’écosystème d’habitation canadien fonctionne de façon efficiente et harmonieuse. Un monde où l’intelligence financière, l’optimisation des structures, la compassion et la créativité dans les solutions mises de l’avant amènent une résolution efficace aux défis et enjeux actuels en Habitation. </p>
                {/* <p>
                  Beatimo est une entreprise renommée dans le domaine de
                  l'analyse et de l'optimisation des performances commerciales.
                  Son expertise réside dans sa capacité à utiliser des données
                  avancées et des techniques d'analyse pour aider les
                  entreprises à améliorer leur efficacité opérationnelle, leur
                  rentabilité et leur croissance.
                </p>
                <p>
                  Grâce à une équipe de professionnels hautement qualifiés et à
                  des technologies de pointe, Beatimo fournit des solutions
                  personnalisées qui permettent aux entreprises de prendre des
                  décisions éclairées et de maximiser leur potentiel.
                </p> */}
                <div className="financier-button">
                  <button className="services-btn" onClick={valeurClick}>
                    découvrir notre équipe
                  </button>
                  <button className="icon-btn">
                    <img
                      src="assets/image/arrow-bottom.png"
                      alt="mission&vision"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="financier-image">
                <img
                  src="assets/image/Rectangle-3.png"
                  className="img-fluid"
                  alt="mission&vission"
                />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="financier-image">
                <img
                  src="assets/image/Rectangle-2.png"
                  className="img-fluid"
                  alt="mission&vission"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MissionAndVision;
